export const dashboardStyles = {
  barChart: {
    border: "1px solid #D1D9EF",
    borderRadius: 2,
    padding: 2,
    margin: "0 auto",
  },
  projectSelect: {
    fontSize: 14,
    fontWeight: 400,
    borderColor: "#D1D9EF",
    borderRadius: 1,
    width: 160,
    color: "#9E9FA1",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: 2,
    },
  },
  calendarContainer: {
    position: "relative",
    width: "auto",
    border: "1px solid #CCD2DE",
    borderRadius: 2,
    padding: 0,
    "&:hover": {
      borderColor: "#666",
    },
  },
  refreshAnimation: (refreshLoading) => {
    return {
      "@keyframes rotate": {
        from: {
          transform: "rotate(0deg)",
        },
        to: {
          transform: "rotate(360deg)",
        },
      },

      "& .refresh-icon": {
        animation: refreshLoading ? "rotate 1s linear infinite" : "none",
      },
    };
  },
  summaryCardContainer: {
    minHeight: 100,
    padding: 1.5,
    borderRadius: 2,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  summaryCard: {
    summaryIndicator: {
      width: 12,
      height: 12,
      borderRadius: "50%",
      marginRight: 1,
    }
  },
};
